import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { store } from 'app/store';
import MprcNotistackAction from 'components/MprcNotistackAction';
import { MprcRequestIndicator } from "components/MprcRequestIndicator";
import i18next from "i18next";
import { SnackbarProvider } from "notistack";
import { AppThemeProvider } from "providers/AppThemeProvider";
import { CoreApiProvider } from 'providers/CoreApiProvider';
import { SessionProvider, useSession } from "providers/SessionProvider";
import { ModalUserProfileProvider } from "providers/UserProfileProvider";
import { Suspense } from "react";
import { Provider } from 'react-redux';
import { Outlet, RouterProvider } from "react-router";
import { RootRouter } from "routes/RootRouter";
import ErrorBoundary from "views/ErrorBoundary";
import { SplashScreen } from "views/SplashScreen";



// Adaptação para React Router 6 com RouteData, uma vez que o createBrowserRouter não permite 'filhos' diretamente.
// Neste caso, o primeiro Route envolve as demais chamadas via propriedade Element.
const RootChildren = () => {
    const session = useSession();
    return <CoreApiProvider>
        <AppThemeProvider>
            <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={session.uiCulture}>
                <SnackbarProvider
                    maxSnack={3}
                    autoHideDuration={3000}
                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                    Components={
                        {
                            mprcAction: MprcNotistackAction,
                        }
                    }
                >
                    <ModalUserProfileProvider>
                        <Outlet />
                    </ModalUserProfileProvider>
                </SnackbarProvider>
            </LocalizationProvider>
        </AppThemeProvider>
    </CoreApiProvider>;
};

/**
 * Aplicação Principal
 */
export const App = () => {
    return (
        <Suspense fallback={<MprcRequestIndicator type="suspense" />}>
            <ErrorBoundary>
                <Provider store={store}>
                    <SessionProvider initialLocale={i18next.language ?? "pt-BR"} splashScreen={SplashScreen}>
                        <RouterProvider router={RootRouter(<RootChildren />)} />
                    </SessionProvider>
                </Provider>
            </ErrorBoundary>
        </Suspense>
    );
};
